<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#0086C8" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.83333 10.3933C6.75333 14.1667 9.84 17.2533 13.62 19.1733L16.5533 16.2333C16.92 15.8667 17.4467 15.76 17.9067 15.9067C19.4 16.4 21.0067 16.6667 22.6667 16.6667C23.4067 16.6667 24 17.26 24 18V22.6667C24 23.4067 23.4067 24 22.6667 24C10.1467 24 0 13.8533 0 1.33333C0 0.593333 0.6 0 1.33333 0H6C6.74 0 7.33333 0.593333 7.33333 1.33333C7.33333 2.99333 7.6 4.6 8.09333 6.09333C8.24 6.55333 8.13333 7.08 7.76667 7.44667L4.83333 10.3933Z"/>
  </svg>
</template>
<script>
export default {
  name: 'IconPhoneSupport'
}
</script>